
export const labels = {
    'en': {
        1: 'Well suited',
        2: 'Suitable',
        3: 'Marginally suitable',
        4: 'Unsuitable',
    },
    'mi': {

    }
}

export let colors = {
    4: '#fdc962',
    3: '#eeee62',
    2: '#c9fd62',
    1: '#85c862',
}